import CheckOut from './check-out';

export default CheckOut;
